import { Component, EventEmitter, Input, Output } from '@angular/core';

import { NgClass, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KENDO_DATEINPUTS } from '@progress/kendo-angular-dateinputs';
import { WindowService } from '@progress/kendo-angular-dialog';
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { KENDO_ICONS } from '@progress/kendo-angular-icons';
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs';
import { KENDO_LABEL, KENDO_LABELS } from '@progress/kendo-angular-label';
import { PDFSERVICE } from '../../../@theme/services/pdfgetfiles.service';
import { TypesServices } from '../../../@theme/services/typeslist.service';
import { AddressFormFieldsComponent } from '../atoms/addressform';
import { CheckBoxComponent } from '../atoms/checkbox';
import { CommentListComponent } from '../atoms/commentform';
import { DatePickerComponent } from '../atoms/datepicker';
import { DropDownComponent } from '../atoms/dropdown';
import { FileComponent } from '../atoms/file';
import { GridReadonlyComponent } from '../atoms/grid';
import { LabelComponent } from '../atoms/label';
import { MulitLineComponent } from '../atoms/multiline';
import { RadioComponent } from '../atoms/radio';
import { TextBoxComponent } from '../atoms/textbox';
@Component({
    selector: 'gd-field-builder',
    styleUrls: ['./test.css'],
    template: `
    <div class="form-group row" [formGroup]="form">
      <label
        *ngIf="field.label !== null && field.name !== 'StatusTypeID'"
        [ngClass]="{
          Notfieldnull: field.label !== null,
          fieldnull: field.label === null
        }"
        [attr.for]="field.label"
      >
        <strong class="text-danger" *ngIf="field.required">*</strong>&nbsp;
        {{ field.label }}&nbsp;&nbsp;<span *ngIf="field.pdfrequired"
          ><img
            src="../../../../assets/images/pdf.gif"
            (click)="GetDisclosureForm(field.pdfPath)"
        /></span>
      </label>
      <div class="card-col" [ngSwitch]="field.type">
        <gd-label
          *ngSwitchCase="'label'"
          [field]="field"
          [form]="form"
          [blotId]="blotId"
        ></gd-label>
        <gd-multi
          *ngSwitchCase="'multiline'"
          [field]="field"
          [form]="form"
        ></gd-multi>
        <gd-comment
          *ngSwitchCase="'gridcomments'"
          [field]="field"
          [form]="form"
        ></gd-comment>
        <gd-datepicker
          *ngSwitchCase="'datepicker'"
          [field]="field"
          [form]="form"
        ></gd-datepicker>
        <gd-dropdown
          *ngSwitchCase="'dropdown'"
          [field]="field"
          [form]="form"
        ></gd-dropdown>
        <gd-textbox
          *ngSwitchCase="'text'"
          [field]="field"
          [form]="form"
        ></gd-textbox>
        <gd-checkbox
          *ngSwitchCase="'checkbox'"
          [field]="field"
          [form]="form"
        ></gd-checkbox>
        <gd-radio
          *ngSwitchCase="'radio'"
          (checkVals)="checkVal($event)"
          [field]="field"
          [form]="form"
        ></gd-radio>
        <gd-file *ngSwitchCase="'file'" [field]="field" [form]="form"></gd-file>
        <gd-grid *ngSwitchCase="'grid'" [field]="field" [form]="form"></gd-grid>
        <gd-address
          *ngSwitchCase="'addressfield'"
          [field]="field"
          [form]="form"
        ></gd-address>
 
      </div>
    </div>
  `,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgIf,
        NgClass,
        NgSwitch,
        NgSwitchCase,
        LabelComponent,
        MulitLineComponent,
        CommentListComponent,
        KENDO_LABEL, KENDO_DATEINPUTS, KENDO_ICONS,
        KENDO_DROPDOWNS,
        KENDO_INPUTS, KENDO_LABELS,
        CheckBoxComponent,
        RadioComponent,
        FileComponent,
        GridReadonlyComponent,
        AddressFormFieldsComponent,
        TextBoxComponent,
        DropDownComponent,
        DatePickerComponent
        
    ]
})
export class FieldBuilderComponent {
  @Input() field: any
  @Input() form: any
  @Input() blotId: number
  @Output() checkValsues = new EventEmitter()
  @Output() pushupone = new EventEmitter()
  @Input() clientId: number
  public listStates: Array<any> = []
  public value = new Date()
  public reptextval: any
  public opened = false
  get isValid() {
    return this.form.controls[this.field.name].valid
  }
  get isDirty() {
    return this.form.controls[this.field.name].dirty
  }
  public windowTop = 500
  public windowLeft = 50
  public offset = 300
  public left = this.offset
  public top = this.offset
  public width = 400
  public height = 350
  constructor(
    private getser: PDFSERVICE,
    private typ: TypesServices,
    private windowService: WindowService,
  ) {
    localStorage.setItem('repalert', 'false')
  }
  pushagain(e: any) {
    this.pushupone.emit(e)
  }
  checkVal(d: string) {
    const unsavedText = localStorage.getItem('UnsavedAlertText')
    if (
      this.field.name === 'AlertRep' &&
      d === 'true' &&
      this.form.get('AlertRepText').value === '' &&
      unsavedText === null
    ) {
      localStorage.setItem('repalert', 'true')
      this.reptextval = true

      if (unsavedText !== null && unsavedText !== '') {
        this.form.get('AlertRepText').setValue(unsavedText)
      }
    } else {
      localStorage.setItem('repalert', 'false')
      this.reptextval = false
    }
  }
  GetDisclosureForm(path: string) {
  const clId = Number(localStorage.getItem('clId') || '0');
  this.getser.GetPdfService(path, clId)
    .subscribe({
      next: (blob: Blob) => {
        if (blob.type !== 'application/pdf') {
          console.error('Expected PDF, got:', blob.type);
          return;
        }
        const url = URL.createObjectURL(blob);
        window.open(
          url,
          '_blank',
          'width=800,height=800'
        );
      },
      error: err => console.error('PDF download failed', err)
    });
}

  /* GetDisclosureForm(path: string) {
    const getclid = localStorage.getItem('clId')
    console.log('getclid' + getclid);
    const clId = Number(getclid)
    console.log('path=' + path + ' ' + 'clId=' + clId);
    this.getser.GetPdfService(path, clId).subscribe((response: any) => {
      const file = new Blob([response], { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(file)
      window.open(
        fileURL,
        '_blank',
        'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=800,height=800'
      );

      /*  window.open(
         fileURL,
         '_blank',
         "directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=800,height=800'",
       ) *
    })
  } */

  public close() {
    this.opened = false
  }
  public onEnd() {
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight
    const positionTop = windowHeight - this.height - this.offset
    const positionLeft = windowWidth - this.width - this.offset

    if (this.top < this.offset) {
      this.top = this.offset
    }

    if (this.top > positionTop) {
      this.top = positionTop
    }

    if (this.left < this.offset) {
      this.left = this.offset
    }

    if (this.left > positionLeft) {
      this.left = positionLeft
    }
  }
}
